import React, { Component } from "react";
import moment from "moment";

import Api from "../../../lib/componentApi";
import Loading from "../../Common/Loading";

export default class Rate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order: null,
      "answer1-1": "",
      "answer1-2": "",
      "answer1-3": "",
      "answer2-1": "",
      "answer2-2": "",
      "answer2-3": "",
      "answer3-1": "",
      "answer3-2": "",
      "answer3-3": "",
      answer1: 0,
      answer2: 0,
      answer3: 0,
      rateText: "Are you satisfied with the order?",
      comment: "",
      lettersNumber: 0
    };
  }

  componentDidMount() {
    const { orderUid } = this.props;
    Api.post("/api/order", { orderUid }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-order");
      } else {
        if (response.status) {
          this.setState({ order: response });
        }
      }
    });
  }

  getRateText = (answer, value) => {
    const { answer1, answer2, answer3 } = this.state;
    if (value === 1) {
      this.setState({
        [`${answer}-2`]: "",
        [`${answer}-3`]: ""
      });
    } else if (value === 2) {
      this.setState({
        [`${answer}-1`]: "",
        [`${answer}-3`]: ""
      });
    } else {
      this.setState({
        [`${answer}-1`]: "",
        [`${answer}-2`]: ""
      });
    }
    let text = "Are you satisfied with the order?";
    if (answer1 && answer2 && answer3) {
      const total = answer1 + answer2 + answer3;
      if (total < 6) {
        text = "We're sorry to hear this. Please comment below.";
      } else if (6 <= total && total < 8) {
        text = "Add a comment below.";
      } else {
        text = "We're glad you liked it. Add a comment below.";
      }
      this.setState({ rateText: text });
    }
  };
  validateRateButton = () => {
    const { answer1, answer2, answer3 } = this.state;
    if (answer1 > 0 && answer2 > 0 && answer3 > 0) {
      return true;
    }
  };
  handleChangeComment = event => {
    const { lettersNumber } = this.state || 0;
    if (lettersNumber < 140) {
      this.setState({
        comment: event.target.value,
        lettersNumber: event.target.value.length
      });
    } else {
      event.preventDefault();
    }
  };
  handleRate = (event, value) => {
    event.preventDefault();
    const target = event.target.id && event.target.id.split("-");
    const answer = (target && target[0]) || "";
    this.setState(
      {
        [answer]: parseInt(value),
        [event.target.id]: "selected"
      },
      () => {
        this.getRateText(answer, value);
      }
    );
  };

  render() {
    const { onClickClose, orderUid, onSubmitRate } = this.props;
    const {
      order,
      rateText,
      comment,
      answer1,
      answer2,
      answer3,
      lettersNumber
    } = this.state;
    const { restaurant, orderDate, total } = order || "";
    const formattedDate = moment(orderDate).format("DD.MM.YYYY");
    return (
      <div>
        <div className="modal-bg" />
        <div className="modal">
          <div className="rate-page">
            {/* Header */}
            <div className="head-general with-back">
              <a
                href="javascript: void(0)"
                className="back"
                onClick={() => onClickClose("rateSection")}
              >
                <img src="/png/chevron-left.png" />
              </a>
              <h4>Order #{orderUid}</h4>
              <a
                href="javascript: void(0)"
                className="close"
                onClick={() => onClickClose("rateSection")}
              >
                <i className="icon icon-close hide-xs" />
              </a>
            </div>
            {/* Header */}
            {(order && (
              <React.Fragment>
                <div className="modal-body">
                  <div>
                    <div className="white-bg mt-10px d-flex justify-content-between padding-box status">
                      <p>{formattedDate}</p>
                      <p className="flex-grow-1">{restaurant.name}</p>
                      <p className="bold">£{parseFloat(total).toFixed(2)}</p>
                    </div>
                  </div>
                  <div className="white-bg mt-10px padding-box icon-list">
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="bold">
                        <span>Food Quality</span>
                      </p>
                      <div className="icons">
                        <img
                          className="rate-image cursor-pointer"
                          id="answer1-1"
                          onClick={e => this.handleRate(e, 1)}
                          src={
                            (this.state["answer1-1"] === "selected" &&
                              "/svg/confused-hover.svg") ||
                            "/svg/confused.svg"
                          }
                        />
                        <img
                          className="rate-image cursor-pointer"
                          id="answer1-2"
                          onClick={e => this.handleRate(e, 2)}
                          src={
                            (this.state["answer1-2"] === "selected" &&
                              "/svg/dull-hover.svg") ||
                            "/svg/dull.svg"
                          }
                        />
                        <img
                          onClick={e => this.handleRate(e, 3)}
                          className="rate-image cursor-pointer"
                          id="answer1-3"
                          src={
                            (this.state["answer1-3"] === "selected" &&
                              "/svg/happy-hover.svg") ||
                            "/svg/happy.svg"
                          }
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="bold">
                        <span>Restaurant Service</span>
                      </p>
                      <div className="icons">
                        <img
                          className="rate-image cursor-pointer"
                          id="answer2-1"
                          onClick={e => this.handleRate(e, 1)}
                          src={
                            (this.state["answer2-1"] === "selected" &&
                              "/svg/confused-hover.svg") ||
                            "/svg/confused.svg"
                          }
                        />
                        <img
                          className="rate-image cursor-pointer"
                          id="answer2-2"
                          onClick={e => this.handleRate(e, 2)}
                          src={
                            (this.state["answer2-2"] === "selected" &&
                              "/svg/dull-hover.svg") ||
                            "/svg/dull.svg"
                          }
                        />
                        <img
                          className="rate-image cursor-pointer"
                          onClick={e => this.handleRate(e, 3)}
                          id="answer2-3"
                          src={
                            (this.state["answer2-3"] === "selected" &&
                              "/svg/happy-hover.svg") ||
                            "/svg/happy.svg"
                          }
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="bold">
                        <span>Delivery Time</span>
                      </p>
                      <div className="icons">
                        <img
                          className="rate-image cursor-pointer"
                          id="answer3-1"
                          onClick={e => this.handleRate(e, 1)}
                          src={
                            (this.state["answer3-1"] === "selected" &&
                              "/svg/confused-hover.svg") ||
                            "/svg/confused.svg"
                          }
                        />
                        <img
                          className="rate-image cursor-pointer"
                          id="answer3-2"
                          onClick={e => this.handleRate(e, 2)}
                          src={
                            (this.state["answer3-2"] === "selected" &&
                              "/svg/dull-hover.svg") ||
                            "/svg/dull.svg"
                          }
                        />
                        <img
                          style={{
                            width: "45px !important",
                            height: "45px !important"
                          }}
                          onClick={e => this.handleRate(e, 3)}
                          className="rate-image cursor-pointer"
                          id="answer3-3"
                          src={
                            (this.state["answer3-3"] === "selected" &&
                              "/svg/happy-hover.svg") ||
                            "/svg/happy.svg"
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="white-bg mt-10px padding-box comment">
                    <h5>{rateText}</h5>
                    <textarea
                      id="comment"
                      onChange={this.handleChangeComment}
                      placeholder="Write your comment here."
                      value={comment}
                    />

                    <p className="count">{lettersNumber}/140</p>
                  </div>
                  {(this.validateRateButton() && (
                    <div
                      className="mt-1 btn-continue"
                      onClick={() =>
                        onSubmitRate({
                          orderUid,
                          foodQuality: answer1,
                          restaurantService: answer2,
                          deliveryTime: answer3,
                          comment
                        })
                      }
                    >
                      <button className="btn btn-blue">Submit</button>
                    </div>
                  )) || <noscript />}
                </div>
              </React.Fragment>
            )) || <Loading />}
          </div>
        </div>
      </div>
    );
  }
}
